import styles from "./index.module.less";

import img from "@/assets/images/main/public.png";

export default function Footer() {
  return (
    <div className={styles.footer}>
      <p>Copyright © 2021-2024 北京元跃科技有限公司</p>
      <p>
        <a href="//vip.meishubao.com/v2/civilizedInternet/" title="文明上网倡议书" target="_blank" rel="noopener noreferrer">文明上网倡议书</a>
      </p>
      {/* <p>
        <img src={img} alt="" />
        <a
          href="http://www.beian.gov.cn/portal/recordQuery?token=a43309b4-a5a7-4f01-a687-6bcdf00f8233"
          target="_blank"
          rel="noopener noreferrer"
        >
          <b>浙公网安备</b> 33010802012256号
        </a>
      </p> */}
      <p>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <b>ICP备案/许可证:</b> 京ICP备2022016901号-14
        </a>
      </p>
    </div>
  );
}
